import React, { useCallback, useEffect, useState } from "react";
import { Trash2, CheckCircle2, Circle, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { PageTitle } from "./AdminDashboard";

const TYPES = [["", "All"], ["prereg", "Hajj Pre-Registration"], ["custom", "Custom Package"], ["contact", "Contact"], ["newsletter", "Newsletter"]];

const AdminInquiries = () => {
  const [type, setType] = useState("");
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin-inquiries", { params: type ? { type } : {} }).then((r) => setItems(r.data)), [type]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (q) => { await api.patch(`/admin-inquiries/${q.id}`, { status: q.status === "new" ? "done" : "new" }); load(); };
  const remove = async (q) => { if (!window.confirm("Delete this inquiry?")) return; await api.delete(`/admin-inquiries/${q.id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-inquiries">
      <PageTitle title="Inquiries" sub="Every form submission from the website lands here." />
      <div className="flex flex-wrap gap-2 mb-6">
        {TYPES.map(([k, l]) => <button key={k} onClick={() => setType(k)} className={`px-4 py-2 rounded-full text-sm font-semibold ${type === k ? "bg-jannah-green text-white" : "bg-white border border-jannah-sand text-jannah-ink/70"}`} data-testid={`inquiry-filter-${k || "all"}`}>{l}</button>)}
      </div>
      <div className="space-y-3">
        {items.length === 0 && <div className="rounded-2xl bg-white border border-jannah-sand p-8 text-center text-sm text-jannah-ink/50">No inquiries found.</div>}
        {items.map((q) => (
          <div key={q.id} className={`rounded-2xl bg-white border p-5 ${q.status === "new" ? "border-jannah-gold/60" : "border-jannah-sand opacity-80"}`} data-testid={`inquiry-${q.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="px-2.5 py-1 rounded bg-jannah-green/10 text-jannah-green text-xs font-bold uppercase">{q.type}</span>
                <span className="font-bold text-jannah-ink">{q.data?.name || q.data?.email || "—"}</span>
                <span className="text-xs text-jannah-ink/50">{new Date(q.created_at).toLocaleString()}</span>
              </div>
              <div className="flex items-center gap-1">
                <button onClick={() => toggle(q)} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold ${q.status === "new" ? "bg-jannah-gold/15 text-jannah-gold" : "bg-jannah-green/10 text-jannah-green"}`} data-testid={`inquiry-toggle-${q.id}`}>
                  {q.status === "new" ? <Circle size={13} /> : <CheckCircle2 size={13} />} {q.status === "new" ? "Mark done" : "Done"}
                </button>
                <button onClick={() => remove(q)} className="p-2 rounded text-red-500 hover:bg-red-50"><Trash2 size={15} /></button>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-4 text-sm">
              {q.data?.phone && <a href={`tel:${q.data.phone}`} className="inline-flex items-center gap-1.5 text-jannah-green"><Phone size={14} /> {q.data.phone}</a>}
              {q.data?.email && <a href={`mailto:${q.data.email}`} className="inline-flex items-center gap-1.5 text-jannah-green"><Mail size={14} /> {q.data.email}</a>}
            </div>
            <dl className="mt-3 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-1.5 text-sm">
              {Object.entries(q.data || {}).filter(([k]) => !["name", "phone", "email"].includes(k)).map(([k, v]) => v && (
                <div key={k} className="flex gap-2"><dt className="text-jannah-ink/50 capitalize shrink-0">{k}:</dt><dd className="text-jannah-ink break-words">{String(v)}</dd></div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminInquiries;
